import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./styles.css";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StructuredData from "./components/StructuredData";
import Home from "./page/Home";
import About from "./page/About";
import Services from "./page/Services";
import HowItWorks from "./page/HowItWorks";
import Contact from "./page/Contact";
import FAQ from "./page/FAQ";
import Blog from "./page/Blog";
import BlogPost from "./page/BlogPost";
import ThankYou from "./page/ThankYou";
import ApplicationForm from "./page/ApplicationForm";
import PrivacyPolicy from "./page/PrivacyPolicy";
import TermsOfService from "./page/TermsOfService";
import HashScroll from "./components/HashScroll";
import EmailPreview from "./page/EmailPreview";
import PDFPreview from "./page/PDFPreview";
import LogoDownload from "./page/LogoDownload";
import UploadDocuments from "./page/UploadDocuments";
import Apply from "./page/Apply";
import AcceptOffer from "./page/AcceptOffer";


function AppContent() {
  const location = useLocation();

  return (
    <div className="bg-white text-slate-900">
      <StructuredData />
      <Header />
      <div className="overflow-x-clip pt-16">
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/application" element={<ApplicationForm />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/email-preview" element={<EmailPreview />} />
            <Route path="/pdf-preview" element={<PDFPreview />} />
            <Route path="/logo-download" element={<LogoDownload />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/upload-documents" element={<UploadDocuments />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/accept-offer" element={<AcceptOffer />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <HashScroll />
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
